define('controllers/enroll',['require','layout'],function(require) {
    'use strict';
    var layout = require('layout');
    var enrollController = {
        load: function (querystring) {
            //todo: this is repeating alot of what's in mainslideshow.js, but don't worry, since the responsive re-design will be overhauling the home page/customer landing functionality anyway...
            return layout.initStatic('/fe/templates/about/enroll').then(function () {
                var loggedInWarning = $('#loggedInWarning');
                if (window.ServerData.user == null) {
                    loggedInWarning.hide();
                } else {
                    loggedInWarning.show();
                }
                enrollController.signUpController = window.app.controllerManager.controllers.signup[0];
                enrollController.signUpController.load(null, querystring).then(function() {
                    $('#firstName').focus();
                });
            });
        },
        unload: function() {
            if (enrollController.signUpController != null) { enrollController.signUpController.unload(); }
        }
    };
    return enrollController;
});

